import * as React from 'react';
// eslint-disable-next-line import/no-unresolved
import { SHOP_ACTIVITY_TYPE } from '@/components/MultiSkuModalGolden/constant';
import Constant from '@/utils/constant';
import { debounce } from '@/utils/index';
import { DietaryTagView } from '@/src/components/MultiSkuModalGolden/Components/DietaryTagView';
import DiscountTag from '@/components/DiscountTag';
import TrackUtils, { EVENT_TYPE } from '@/components/MultiSkuModalGolden/utils/TrackUtils';
import {
  GoodDetailData, ShopEntranceInfo, GoodDetailSkuList, ShopInfo,
  BasicNutritionAllergenTypeEnum,
  NutritionAllergenTypeEnum
} from '@/pages/shop/c_shop_golden/component';
import InfoModal from '@/components/MultiSkuModalGolden/Components/NutritionAllergenInfo/InfoModal';
import '@/components/MultiSkuModalGolden/Components/FoodImage/index.css';

const WMRouter = Mach.requireModule('Router');
const SLCommon = Mach.requireModule('SLCommon');

interface IProps {
  curGoodDetail: GoodDetailData;
  source?: number;
  renderMultiSpuView?: () => void;
  /** 一口价商品多spu的数量 */
  sameShopSpuListLength?: number;
  defaultImg?: string;
  selectedSku: GoodDetailSkuList;
  curSkuDiscountPriceIndex: number;
  curSkuIsMeetSillAmount: number;
  shopInfo: ShopInfo;
}

interface IState {
  /** 副标题description箭头是否展示 */
  showDescArrow: boolean;
  /** 副标题description是否展开 */
  unfold?: boolean;
  modalSpread: boolean; // 营养成分/过敏源modal展开/收起状态
  currentSpreadType: BasicNutritionAllergenTypeEnum; // 当前展开的类型
  reportMVTypes: {
    [key in NutritionAllergenTypeEnum]: boolean; // 是否已经上报MV（因切换SKU不再重新上报，故需记录)
  };
  iconCenterX: {
    [key in BasicNutritionAllergenTypeEnum]: number; // 营养成分/过敏源modal 分别记录left值
  };
  iconCenterY?: number; // 营养成分/过敏源modal top值
}

export default class GoodDetailFoodImage extends React.Component<IProps, IState> {
  componentDidMount() {
  }

  constructor(props) {
    super(props);
    this.state = {
      showDescArrow: false,
      unfold: false,
      modalSpread: false, // 营养成分/过敏源modal展开/收起状态 默认收起
      currentSpreadType: BasicNutritionAllergenTypeEnum.Nutrition, // 当前展开的类型 默认营养成分
      iconCenterX: {
        [BasicNutritionAllergenTypeEnum.Nutrition]: 0,
        [BasicNutritionAllergenTypeEnum.Allergen]: 0,
      },
      iconCenterY: 0, // 营养成分/过敏源modal top值 默认0
      reportMVTypes: {
        [NutritionAllergenTypeEnum.Calorie]: false,
        [NutritionAllergenTypeEnum.Nutrition]: false,
        [NutritionAllergenTypeEnum.Allergen]: false,
      },
    };
  }

  _renderMultiSpuView = () => {
    if (this.props.renderMultiSpuView) {
      return this.props.renderMultiSpuView();
    }
    return null;
  }

  onClickShopEntry = debounce((source, shopEntranceInfo: ShopEntranceInfo | undefined) => {
    // MC
    shopEntranceInfo?.shopId && TrackUtils.reportFixedPriceShopEntry(EVENT_TYPE.MC, source, shopEntranceInfo.shopId);
    const scheme = `${Constant.SHOP_PAGE}&shopId=${shopEntranceInfo?.shopId}&categoryId=${shopEntranceInfo?.categoryId}&spuId=${shopEntranceInfo?.spuId}`;
    WMRouter.navigateTo(scheme);
  })

  /** 一人食 门店入口 */
  _renderVisitShopEntry = (poisiton = 'top', source) => {
    const { curGoodDetail } = this.props;
    const { shopEntranceInfo } = curGoodDetail;
    // MV
    shopEntranceInfo?.shopId && TrackUtils.reportFixedPriceShopEntry(EVENT_TYPE.MV, source, shopEntranceInfo.shopId);

    return (
      <view
        onClick={() => this.onClickShopEntry(source, shopEntranceInfo)}
        className={`${poisiton === 'top' ? 'visit-shop-container' : 'visit-shop-bottom-container'}`}
      >
        <image className="icon-spoon-fork" src="assets://fixprice/spoon_fork_icon.png" />
        <text className="visit-shop-text" content={shopEntranceInfo?.entranceText} />
        <image className="icon-spoon-fork" autoRTL src="assets://shop/icon_arrow_right_bold_golden.png" />
      </view>
    );
  }

  clickMore = () => {
    this.setState({
      unfold: true,
    });
  }

  render() {
    const {
      curGoodDetail, selectedSku, sameShopSpuListLength, defaultImg, renderMultiSpuView, source
    } = this.props;

    const {
      unfold, showDescArrow, modalSpread,
    } = this.state;
    const { shopEntranceInfo } = curGoodDetail;
    const width = Mach.env.screenWidth;
    const moreClassName = unfold ? 'food-description-line-more' : 'food-description-line2';
    const imgUrl = defaultImg || curGoodDetail?.pictures[0];
    // ----- mpweb适配origin -----
    // const height = Math.floor(Mach.env.screenWidth * (3 / 4));
    // ----- mpweb适配change -----
    let height = Math.floor(Mach.env.screenWidth * (3 / 4));
    try {
      // @ts-ignore
      if (Mach.env?.isH5) {
        height = height > 280 ? 280 : height;
      }
    } catch (e) {
      console.log(e);
    }
    // ----- mpweb适配       -----
    const shopHeadImageCacheCDNParam = `${Mach.env.screenWidth * Mach.env.scale}.${height * Mach.env.scale}.100`;
    const isRenderSingleSku = curGoodDetail?.skuList.length === 1 && !curGoodDetail?.skuList[0].skuSpec;
    /**
     * 此处是因为x号改成到里面之后，使用了固定定位。所以下面的元素要给x号预留好位置
     *
     * 图片
     * 优惠
     * 商品名称
     *
     * 都需要根据是否存在来给x号留一个位置。具体的值其实都是之前有的。本次就是新增了一个状态栏和下内边距
     */
    const calculateFoodNameMarginTop = () => {
      if (renderMultiSpuView) {
        return 4;
      }
      if (imgUrl) {
        return 16;
      }
      if (!selectedSku?.aroundLabel) {
        return Mach.env.statusBarHeight + 10; // UI设定为16 - x号的下边距6
      }
      return 0;
    };
    const foodNameMarginTop = calculateFoodNameMarginTop();

    const richTextContent: any = [
      {
        type: 'text',
        text: curGoodDetail.description,
        fontSize: 12, // Adjust text size
        color: '#4D4D4D',
      },
    ];

    return (
      <view
        className="container"
        style={{
          paddingTop: !imgUrl ? 44 : 0, // 这是给没有商品图片的时，关闭叉号容器预留的位置
        }}
      >
        {imgUrl
          && (
            <view>
              <image
                resizeMode="aspectFill"
                className="image-view"
                style={{ width, height: Math.floor(height) }}
                src={imgUrl}
                cdnOptimizationSize={shopHeadImageCacheCDNParam}
                error="assets://placeholder/icon_placeholder_4:3.png"
                placeholder="assets://placeholder/icon_placeholder_4:3.png"
              />
              <view className="img-shadow" />
            </view>
          )}
        {this._renderMultiSpuView()}
        {/*// ----- mpweb适配origin -----*/}
        {/*{this.renderAroundLabel()}*/}
        {/*// ----- mpweb适配change -----*/}
        {this.renderAroundLabel(height)}
        {/*// ----- mpweb适配       -----*/}
        {/* 有多个商品规格时，门店入口展示在标题上面 */}
        {
          shopEntranceInfo?.entranceText?.length && sameShopSpuListLength
            ? (
              <>
                {
                  this._renderVisitShopEntry('top', source)
                }
                <view className="visit-shop-separate-grey" />
              </>
            ) : null
        }
        <view className="detail-content-header">
          <text
            className="food-name"
            style={{ marginTop: foodNameMarginTop }}
            content={curGoodDetail.name}
          />
          {
            isRenderSingleSku ? (
              this._renderSingleSku(curGoodDetail)
            ) : null
          }
          {!!curGoodDetail.description && (
            <view
              className="detail-container"
              onClick={this.clickMore}
            >
              <rich-text
                className={`food-description ${moreClassName}`}
                content={richTextContent}
                onLayout={(frame) => {
                  const descLength = SLCommon.widthForText({
                    content: curGoodDetail.description,
                    fontSize: 12,
                    fontFamily: 'KeeTa-Regular'
                  });
                  if (descLength > Math.ceil(frame.detail.width) * 2) {
                    this.setState({
                      showDescArrow: true
                    });
                  }
                }}
              />
              {
                showDescArrow && !unfold
                && (
                  <image
                    className="food-more-img"
                    src="assets://shop/icon_arrow_bottom_grey.png"
                  />
                )
              }
            </view>
          )}

          {/* 展示卡路里/营养成分/过敏源 title*/}
          {this._renderInfoTitle()}
        </view>
        {/* 展示营养成分过敏源 Modal */}
        {modalSpread && this._renderInfoModal()}

        {/* 只有一个商品规格时，门店入口展示在标题下面 */}
        {
          shopEntranceInfo?.entranceText?.length && !sameShopSpuListLength
            ? this._renderVisitShopEntry('bottom') : null
        }
      </view>
    );
  }

  /** 卡路里/营养成分/过敏源 title */
  _renderInfoTitle = () => {
    const {
      source, shopInfo, curGoodDetail, selectedSku
    } = this.props;

    const { reportMVTypes } = this.state;

    const { extraInfo, calorie } = selectedSku || {};
    const {
      burnoutDurationInfo, nutritionInfo, allergiesInfo, caffeineInfo, sodiumInfo
    } = extraInfo || {};

    const showDietaryTag = Boolean(calorie || burnoutDurationInfo?.title || nutritionInfo?.title || allergiesInfo?.title
      || caffeineInfo?.title || sodiumInfo?.title);
    if (!showDietaryTag) {
      return null;
    }

    const tagData = {
      calorie,
      ...(extraInfo || {})
    };
    const maxWidth = Mach.env.screenWidth - 32;
    return (
      <view className="dietary-tag-container">
        <DietaryTagView
          data={tagData}
          source={source}
          shopId={shopInfo?.shopId}
          spuId={curGoodDetail.spuId}
          skuId={selectedSku.skuId}
          maxWidth={maxWidth}
          onReportedMV={this.onReportedMV}
          reportMVTypes={reportMVTypes}
          onClickTagIcon={this.onModalSpreadChange}
        />
      </view>
    );
  }

  /** 营养成分/过敏源 modal */
  _renderInfoModal = () => {
    const { iconCenterX, iconCenterY = 0, currentSpreadType } = this.state;
    const { selectedSku } = this.props;

    const { extraInfo } = selectedSku || {};

    return (
      <InfoModal
        currentSpreadType={currentSpreadType}
        extraInfo={extraInfo}
        onModalSpreadChange={this.onModalSpreadChange}
        iconCenterX={iconCenterX}
        iconCenterY={iconCenterY}
      />
    );
  }

  /** 处理是否点开查看 营养成分/过敏源
   * @param isSpread 是否展开
   * @param iconCenterX icon中心点 x 坐标 用于定位modal
   * @param iconCenterY icon中心点 y 坐标 用于定位modal
   * @param type 类型 Nutrition | Allergen
   */
  onModalSpreadChange = (params) => {
    const {
      isSpread,
      iconCenterX,
      iconCenterY,
      type,
    } = params;
    this.setState((prevState) => ({
      modalSpread: isSpread,
      currentSpreadType: type,
      iconCenterX: {
        ...prevState.iconCenterX,
        [type]: iconCenterX,
      },
      iconCenterY,
    }));
  }

  /** 是否已经上报MV（因切换SKU不再重新上报，故需记录上报状态）
   * @param reportMVType 上报类型
   */
  onReportedMV = (reportMVType: NutritionAllergenTypeEnum) => {
    this.setState((prevState) => ({
      reportMVTypes: {
        ...prevState.reportMVTypes,
        [reportMVType]: true,
      },
    }));
  }

  _renderSingleSku = (curGoodDetail) => {
    // 只有一个规格
    const { curSkuDiscountPriceIndex: discountPriceIndex = 0, curSkuIsMeetSillAmount: isMeetSillAmount } = this.props;
    const item = curGoodDetail.skuList[0];
    // 满折多阶梯，展示对应阶梯的价格和标签
    const discountPriceList = item.discountPriceList || [];
    const discountPriceText = discountPriceList[discountPriceIndex]?.discountPrice?.displayText;
    const discountPricePromotionTags = discountPriceList[discountPriceIndex]?.promotionTags?.[0];
    const discountPrice = item.discountPrice ? item.discountPrice?.displayText : item.originPrice.displayText;
    const originPrice = item.originPrice?.displayText;
    const showOrigin = discountPrice !== originPrice;
    const dynamicTag = item.promotionTags ? item.promotionTags[0].discountTag : undefined;
    const promotionTagInfo = discountPriceList[discountPriceIndex]?.promotionTagInfo;
    const fullDiscountTag = promotionTagInfo?.discountTag;
    /** 新人折扣菜标签（仅折扣菜有） */
    const discountTypeTag = item?.promotionTagInfo?.discountTypeTag;
    const discountTag = item?.promotionTagInfo?.discountTag;
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {
          // 参与满折活动
          item.activityInfoList?.[0].activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT
            ? (
              <view className="group-item-price-container">
                <text className="group-item-price" content={originPrice} />

                {
                  isMeetSillAmount
                    ? (
                      <view>
                        <text
                          className="group-price-discount-price-bold-text"
                          style={{ color: curGoodDetail.extraInfo?.discountPriceColor || '#F14E24' }}
                          content={discountPriceText}
                        />
                        {/* 满足满折多阶梯条件时展示 */}
                        {fullDiscountTag ? (
                          <view className="discount-tag-margin-left">
                            <DiscountTag tag={fullDiscountTag} />
                          </view>
                        ) : null}
                      </view>
                    ) : null
                }

              </view>
            )
            : (
              <view className="group-item-price-column-container">
                <view className="group-item-price-container">
                  <text className="group-item-price" content={discountPrice} style={{ marginRight: 0 }} />
                  {showOrigin && <text className="group-item-origin-price" style={{ marginLeft: 4 }} content={originPrice} />}
                  {/* 折扣比例 */}
                  {discountTag ? (
                    <view className="discount-tag-margin-left">
                      <DiscountTag tag={discountTag} />
                    </view>
                  ) : null}
                </view>
                {/* 新客折扣菜 */}
                {discountTypeTag ? (
                  <view className="spu-discount-type-tag">
                    <DiscountTag tag={discountTypeTag} />
                  </view>
                ) : null}
              </view>
            )
        }
      </>
    );
  }

  // ----- mpweb适配origin -----
  // renderAroundLabel = () => {
  //   const { curGoodDetail, defaultImg, selectedSku } = this.props;
  //   const width = Mach.env.screenWidth;
  //   const height = (width * 3) / 4;
  // ----- mpweb适配change -----
  renderAroundLabel = (height) => {
    const { curGoodDetail, defaultImg, selectedSku } = this.props;
    // const width = Mach.env.screenWidth;
    // const height = (width * 3) / 4;
    // ----- mpweb适配       -----
    const imgUrl = defaultImg || curGoodDetail?.pictures[0];
    const aroundLabel = selectedSku.aroundLabel;
    if (!aroundLabel) {
      return;
    }
    const { extraInfo: { themeColor = '', backgroundColor = 'linear-gradient(180deg, #FFFBD9 11%, #FFF9A8 84%)', discountProductIcon = 'assets://shop/icon_discount.png' } = {} } = curGoodDetail;
    // 919活动颜色值
    // const bgColor = source === SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE ? '#FFFFFF' : aroundLabel.bgColor;
    if (imgUrl) {
      return (
        <view
          className="around-label-container"
          style={{
            top: Math.floor(height) - 44,
            left: 0,
            width: Mach.env.screenWidth,
          }}
        >
          <view className="around-inner-container" style={{ background: backgroundColor }}>
            {aroundLabel?.icon?.length > 0 ? (<image className="around-label-icon" src={discountProductIcon} />) : null}
            <text className="around-label" content={aroundLabel.activityTitle} style={{ color: themeColor }} />
            <text className="around-label-sub" content={aroundLabel.limitText} style={{ color: themeColor }} />
          </view>
        </view>
      );
    } else {
      return (
        <view
          className="around-label-container-no-image"
          style={{
            width: Mach.env.screenWidth - 4,
            marginTop: Mach.env.statusBarHeight + 10, // x 号容器高度44，底部padding 4，再补4，达到ui设计高度
            background: backgroundColor
          }}
        >
          {aroundLabel?.icon?.length > 0 ? (<image className="around-label-icon" src={discountProductIcon} />) : null}
          <text className="around-label" content={aroundLabel.activityTitle} style={{ color: themeColor }} />
          <text className="around-label-sub" content={aroundLabel.limitText} style={{ color: themeColor }} />
        </view>
      );
    }
  };
}
